import Toolbar from '../toolbar/Toolbar';
import Sidebar from '../sidebar/Sidebar';
import Canvas from '../canvas/Canvas';
import PropertiesPanel from '../properties/PropertiesPanel';
import PageStrip from '../pages/PageStrip';
import ValidationPanel from '../validation/ValidationPanel';
import AmpCodePanel from '../export/AmpCodePanel';
import MediaLibraryModal from '../media/MediaLibraryModal';
import { useEditorStore } from '../../store/editorStore';

export default function AppLayout() {
  const showValidationPanel = useEditorStore((s) => s.showValidationPanel);
  const showAmpCodePanel = useEditorStore((s) => s.showAmpCodePanel);
  const isMediaLibraryOpen = useEditorStore((s) => s.isMediaLibraryOpen);
  const previewMode = useEditorStore((s) => s.previewMode);
  const isEditMode = previewMode === 'edit';

  return (
    <div className="flex flex-col h-screen overflow-hidden" style={{ background: 'var(--t-bg)' }}>
      {/* Top Toolbar */}
      <Toolbar />

      {/* Main Content Area */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar */}
        {isEditMode && <Sidebar />}

        {/* Center: Canvas + Page Strip */}
        <div className="flex flex-col flex-1 overflow-hidden">
          <div className="flex-1 overflow-hidden relative">
            <Canvas />

            {/* Floating panels */}
            {showValidationPanel && (
              <div className="absolute right-4 top-4 w-80 z-30">
                <ValidationPanel />
              </div>
            )}
            {showAmpCodePanel && (
              <div className="absolute right-4 top-4 w-[480px] z-30">
                <AmpCodePanel />
              </div>
            )}
          </div>

          {/* Page Strip */}
          <PageStrip />
        </div>

        {/* Right Properties Panel */}
        {isEditMode && <PropertiesPanel />}
      </div>

      {/* Media Library Modal */}
      {isMediaLibraryOpen && <MediaLibraryModal />}
    </div>
  );
}
